/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Student_DescInputs */

const en_settings_student_desc = /** @type {(inputs: Settings_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfect for students and early-career job seekers.`)
};

const de_settings_student_desc = /** @type {(inputs: Settings_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfekt für Studenten und Berufseinsteiger.`)
};

const fr_settings_student_desc = /** @type {(inputs: Settings_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parfait pour les étudiants et les chercheurs en début de carrière.`)
};

const es_settings_student_desc = /** @type {(inputs: Settings_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfecto para estudiantes y buscadores de empleo al inicio de su carrera.`)
};

const it_settings_student_desc = /** @type {(inputs: Settings_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfetto per studenti e chi cerca lavoro all'inizio della carriera.`)
};

const nl_settings_student_desc = /** @type {(inputs: Settings_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfect voor studenten en sollicitanten in de vroege carrièrefase.`)
};

const pl_settings_student_desc = /** @type {(inputs: Settings_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idealny dla studentów i osób na początku kariery.`)
};

const fi_settings_student_desc = /** @type {(inputs: Settings_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täydellinen opiskelijoille ja varhaisuralla oleville työnhakijoille.`)
};

const da_settings_student_desc = /** @type {(inputs: Settings_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfekt til studerende og tidlige karriere jobsøgende.`)
};

const sv_settings_student_desc = /** @type {(inputs: Settings_Student_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfekt för studenter och tidiga karriärsjobbsökande.`)
};

/**
* | output |
* | --- |
* | "Perfect for students and early-career job seekers." |
*
* @param {Settings_Student_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_student_desc = /** @type {((inputs?: Settings_Student_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Student_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_student_desc(inputs)
	if (locale === "fr") return fr_settings_student_desc(inputs)
	if (locale === "es") return es_settings_student_desc(inputs)
	if (locale === "it") return it_settings_student_desc(inputs)
	if (locale === "nl") return nl_settings_student_desc(inputs)
	if (locale === "pl") return pl_settings_student_desc(inputs)
	if (locale === "fi") return fi_settings_student_desc(inputs)
	if (locale === "da") return da_settings_student_desc(inputs)
	if (locale === "sv") return sv_settings_student_desc(inputs)
	return en_settings_student_desc(inputs)
});